import React from 'react';

export const RenderPS = ({ color, x, y, scale = 0.05, side = 'A', rotate = 0 }) => {
  return (
    <g transform={`translate(${x},${y}) scale(${scale}) rotate(${rotate})`}>
      <g style={{ transformOrigin: '0px 150px' }}>

        <path d="M 350 -60 L 350 60 L -10 60 L -10 -60 L 350 -60 Z"
          fill="#BFBFBF"
          stroke="#191919"
          strokeWidth='8px'
          strokeLinejoin="round"
          fillRule="evenodd" />

        <path d="M -10 60 L -10 -60 L -110 -120 L -350 -120 L -350 120 L -110 120 L -10 60 Z"
          fill={color}
          stroke="#191919"
          strokeWidth='8px'
          strokeLinejoin="round"
          fillRule="evenodd" />

        <path d="M -110 -120 L -110 120"
          stroke="#191919"
          strokeWidth='4px'
          fill="none" />

      </g>
    </g>
  );
};

